import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { ChildSearchRequestDataView } from '../model/search-child-request-data-view';

@Injectable({
    providedIn: 'root'
})
export class SearchChildrenService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getSimpleSearch(requestPayload: ChildSearchRequestDataView): Observable<any> {
        return this.post<any>(EndPoints.studentSimpleSearch, false, '', requestPayload).pipe(
            switchMap((result) => {
                return of(result);
            })
        );
    }
}
